function snakeCase(string: string): string {
  return string.trim().toLowerCase().split(' ').join('_');
}

export default snakeCase;
